// extracted by mini-css-extract-plugin
export var card = "_m0-1";
export var summary = "_m0-0";